
import { EMPTY_COLLECTION_HDR_SEARCH_CRITERIA } from "domain/entity/Collection/CollectionHeaderSearchCriteria";
import moment from "moment";
import { useCollectionVM } from "presentation/hook/Collection/useCollectionVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCollectionTracked } from "presentation/store/Collection/CollectionProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { CollectionRightPanel } from "./CollectionRightPanel";
import CollectionSearchPanel from "./CollectionSearchPanel";
import CollectionTitleBar from "./CollectionTitleBar";

export const CollectionMaintenance: React.FC = () => {
    const [collectionState] = useCollectionTracked();
    const collectionVM = useCollectionVM();
    const { isShowSearchPanel } = collectionState;
    const [isLoading, setIsLoading] = useState(true);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    useEffect(() => {
        collectionVM.setIsSearchLoading(true);
        const initialScreen = async () => {
            let newSearchCriteria = null;
            newSearchCriteria = {
                ...EMPTY_COLLECTION_HDR_SEARCH_CRITERIA
            };
            newSearchCriteria = {
                ...newSearchCriteria,
                // dateFrom: moment("2021-01-01").startOf("day").toDate(),
                dateFrom: moment().startOf("day").toDate(),
                notYetFinal: "Y"
            };
            await Promise.allSettled([
                collectionVM.loadDropdownOption(),
                (operatingUnit === 'SAPT' || operatingUnit === 'KICT') && collectionVM.onSearch(newSearchCriteria),
            ]);
        }
        initialScreen().then((data) => {
            collectionVM.setIsSearchLoading(false);
            setIsLoading(false);
        }).catch((error) => {
            collectionVM.setIsSearchLoading(false);
            setIsLoading(false);
        });

    }, [collectionVM, operatingUnit])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${(isShowSearchPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <CollectionTitleBar />
            <SliderPanel
                isOpen={true}
                leftSectionWidth={isShowSearchPanel ? '30%' : '0%'}
                rightSectionWidth={isShowSearchPanel ? '70%' : '100%'}
                draggable={false}
                leftChildren={<CollectionSearchPanel />}
                rightChildren={<CollectionRightPanel />}
            />
        </div>
    </>
}